import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import PendingApproval from "../pages/PendingApproval";

export default function ProtectedRoute({ children, requireRoles }) {
  const { user, loading, hasAnyRole, hasRole } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-2 h-10 bg-[#D90429] animate-pulse" />
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  if (!hasAnyRole) return <PendingApproval />;
  if (requireRoles && requireRoles.length && !hasRole(...requireRoles)) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="forbidden">
        <div className="max-w-md text-center">
          <div className="overline">Access denied</div>
          <h1 className="font-display text-3xl font-black tracking-tighter mt-2">You don&rsquo;t have permission to view this section.</h1>
          <p className="mt-3 text-[#717680]">Required role: {requireRoles.join(" or ")}. Contact the administrator to request access.</p>
        </div>
      </div>
    );
  }
  return children;
}
